import React, { Component } from 'react';
import ReactGA from 'react-ga';

import ConfigService from '../../services/config';

import DataContext from '../../contexts/data';
import ConfigContext, { DefaultConfig } from '../../contexts/config';

import { DisabledAppError } from '../../errors';

import './app.scss';
import layouts from '../../layouts';

const isCustomFont = font => font.includes('http');
const generateFontFace = font => {
  return `
		@font-face {
			font-family: "CustomFont";
			src: url("${font}");
		}

	`;
};
const generateCustomStyles = config => {
  return `
	${isCustomFont(config.font) ? generateFontFace(config.font) : ''}
	${
    config.style === 'bubbles' && config.bubble_color
      ? `.tweet--bubbles .tweet__content::after {
  border-color: ${config.bubble_color} transparent;
}`
      : ''
  }
	`;
};

export default class Application extends Component {
  constructor(props) {
    super(props);

    const reducedProps = Object.keys(props.config.payload).reduce((acc, key) => {
      if (props.config.payload[key] !== '' && props.config.payload[key] !== undefined) {
        acc[key] = props.config.payload[key];
      }
      return acc;
    }, {});

    this.state = {
      data: { results: [] },
      usageKey: props.config.usageKey,
      credentials: props.config.auth,
      config: Object.assign({}, { configKey: props.configKey }, DefaultConfig, reducedProps)
    };
  }

  componentDidMount() {
    this.fetchData();
    // Refresh per 5 mins
    setInterval(() => {
      this.refresh();
    }, 5 * 60 * 1000);
  }

  refresh() {
    this.checkStatus()
      .then(statusResult => {
        if (statusResult) {
          this.fetchData();
        } else {
          throw new DisabledAppError();
        }
      })
      .catch(error => {
        this.setState({ error });
      });
  }

  async checkStatus() {
    try {
      const config = await ConfigService.getConfig(this.state.config.configKey);
      if (config.disabled) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      this.setState({ error });
      ReactGA.exception({
        description: `${error.name}: ${error.message} (${error.code || 500})`,
        fatal: true
      });
    }
  }

  async fetchData() {
    try {
      this.setState({ error: null });
      const data = await this.props.dataProvider.getData(
        this.state.usageKey,
        this.state.config,
        this.state.credentials
      );
      this.setState({ data });
    } catch (error) {
      this.setState({ error });
      ReactGA.exception({
        description: `${error.name}: ${error.message} (${error.code || 500})`,
        fatal: true
      });
    }
  }

  render() {
    const { config, data, error } = this.state;
    const styleClass = `app--${config.style}`;
    const fontClass = !isCustomFont(config.font) ? `app--${config.font}` : '';
    let Layout = layouts.defaultLayout;

    if (['split-screen-animated', 'split-screen-no-animation'].includes(config.style)) {
      Layout = layouts.splitLayout;
    }

    return (
      <DataContext.Provider value={data}>
        <ConfigContext.Provider value={config}>
          <Layout
            styleClass={styleClass}
            fontClass={fontClass}
            config={config}
            error={error}
            generateCustomStyles={generateCustomStyles}
          />
        </ConfigContext.Provider>
      </DataContext.Provider>
    );
  }
}
